/* VÀLIEN — blog yazısı · 24.09.2026
 * Haftalık ritim ve adım şeridi artık sunucuda üretiliyor (snippets/valien-makale-icerik.liquid).
 * Bu dosya yalnızca: içindekiler (geniş ekran) + görününce dolma animasyonu.
 */
(function () {
  const basla = () => {
  const govde = document.querySelector('.blog-post-content.rte');
  if (!govde) return;
  const kok = govde.querySelector('rte-formatter') || govde;
  const el = (t, c, h) => { const e = document.createElement(t); if (c) e.className = c; if (h != null) e.textContent = h; return e; };
  const iki = (n) => String(n).padStart(2, '0');

  const h2 = [...kok.querySelectorAll(':scope > h2')];
  if (h2.length >= 3 && !document.querySelector('.vm-icindekiler')) {
    const nav = el('nav', 'vm-icindekiler');
    nav.setAttribute('aria-label', 'Bu yazıda');
    nav.append(el('p', 'vm-icindekiler__bas', 'Bu yazıda'));
    const ol = el('ol');
    h2.forEach((h, i) => {
      h.id = h.id || 'bolum-' + (i + 1);
      const li = el('li');
      const a = el('a');
      a.href = '#' + h.id;
      a.append(el('span', 'vm-etiket', iki(i + 1)), el('span', 'vm-icindekiler__ad', h.textContent.trim()));
      li.append(a, el('span', 'vm-icindekiler__cizgi'));
      ol.append(li);
    });
    nav.append(ol);
    govde.before(nav);
    const lis = [...ol.children];
    const guncelle = () => {
      const y = window.innerHeight * 0.35;
      let akt = -1;
      h2.forEach((h, i) => { if (h.getBoundingClientRect().top < y) akt = i; });
      lis.forEach((li, i) => {
        li.classList.toggle('is-aktif', i === akt);
        li.classList.toggle('is-okundu', i < akt);
        let p = 0;
        if (i === akt) {
          const b = h2[i].getBoundingClientRect().top;
          const s = h2[i + 1] ? h2[i + 1].getBoundingClientRect().top : govde.getBoundingClientRect().bottom;
          p = Math.min(1, Math.max(0, (y - b) / Math.max(1, s - b)));
        }
        li.style.setProperty('--ilerleme', i < akt ? 1 : p);
      });
      const r = govde.getBoundingClientRect();
      nav.classList.toggle('is-gorunur', r.top < window.innerHeight * 0.6 && r.bottom > 200);
    };
    let bekle = false;
    window.addEventListener('scroll', () => { if (!bekle) { bekle = true; requestAnimationFrame(() => { guncelle(); bekle = false; }); } }, { passive: true });
    guncelle();
  }

  /* Animasyon: öğeler zaten dolu çiziliyor; JS varsa önce boşaltıp görününce doldur */
  const hedef = [...document.querySelectorAll('.vm-ritim, .vm-sira')].filter((x) => x.getBoundingClientRect().top > window.innerHeight);
  if (!('IntersectionObserver' in window) || !hedef.length) return;
  hedef.forEach((x) => x.classList.add('vm-bekliyor'));
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.remove('vm-bekliyor'); io.unobserve(e.target); } }), { threshold: 0.2 });
  hedef.forEach((x) => io.observe(x));
  setTimeout(() => hedef.forEach((x) => x.classList.remove('vm-bekliyor')), 8000);
  };
  let calisti = false;
  const hazir = () => { if (!calisti) { calisti = true; requestAnimationFrame(basla); } };
  if (window.customElements && document.querySelector('rte-formatter')) {
    customElements.whenDefined('rte-formatter').then(hazir);
    setTimeout(hazir, 1500);
  } else hazir();
})();
